<template>
  <b-modal
    :visible="value"
    :title="modalTitle"
    size="md"
    hide-footer
    centered
    @change="modalChangeEvent"
  >
    <BfSelect
      :value="categoria"
      data-key="categoria"
      label="Categoría"
      :errors="formErrors"
      :options="categorySelectOptions"
      @update="updateForm"
    />

    <div v-if="formattedErrors" class="mt-2">
      <p class="text-danger" v-html="formattedErrors" />
    </div>

    <div class="mt-4 text-right">
      <BfButton variant="secondary" class="mr-3" @click="modalChangeEvent(false)">Cancelar</BfButton>
      <BfButton @click="saveFormData">{{saveButtonLabel}}</BfButton>
    </div>
  </b-modal>
</template>

<script>
import get from 'lodash.get';
import { documentAPI } from '@/api';

export default {
  name: 'documentacionChangeCategoryodal',

  props: {
    initialFormData: {
      type: Array,
      default: () => [],
    },
    formErrors: {
      type: Object,
    },
    value: {
      type: Boolean,
      default: false,
    },
    categorias: {
      type: Array,
    },
    mainCategory: {
      type: String,
    },
  },

  data() {
    return {
      formData: this.initialFormData,
      selectedCategoria: {},
    };
  },

  methods: {
    updateForm({ key, value }) {
      this.selectedCategoria = value;
    },

    modalChangeEvent(visible) {
      this.formData = !visible ? {} : this.initialFormData;
      this.$emit('input', visible);
    },

    async saveFormData() {
      try {
        const { data, message } = await documentAPI.changeCategoriesDocuments({
          documentsId: this.formData,
          categoryId: this.selectedCategoria,
        });
        this.$emit('input', false);
        this.$emit('updateDocuments');
        this.$bfNotify({
          type: 'success',
          title: 'Edición correcta',
          message,
        });
      } catch ({ message }) {
        this.$bfNotify({
          type: 'error',
          title: 'Error',
          message,
        });
      }

      // this.$emit("save-data", this.formData);
    },
  },

  computed: {
    categoria() {
      return this.mainCategory;
    },

    categorySelectOptions() {
      return this.categorias.map((label, index) => ({
        label,
        value: index,
      }));
    },
    plural() {
      if (this.formData.length > 1) {
        return true;
      }
    },

    formattedErrors() {
      if (
        !this.formErrors ||
        (this.formErrors && !Object.keys(this.formErrors).length)
      ) {
        return null;
      }

      return Object.keys(this.formErrors)
        .filter(key => ['categoria'].indexOf(key) === -1)
        .map((key) => {
          const errors = this.formErrors[key] || [];

          return errors.join('<br />');
        })
        .join('<br />');
    },

    modalTitle() {
      return `Editar categoria${this.plural ? 's' : ''}`;
    },

    saveButtonLabel() {
      return `Editar categoria${this.plural ? 's' : ''}`;
    },

    nameFieldLabel() {
      return `Selecciona la nueva categoría para ${
        this.plural ? 'los documentos' : 'el documento'
      }`;
    },

    nameFieldPlaceholder() {
      return !this.plural
        ? 'Selecciona del fichero'
        : 'Selecciona el nombre para los ficheros';
    },
  },

  watch: {
    initialFormData(newData) {
      this.formData = newData;
    },
  },
};
</script>

<style lang="scss" scoped>
.category-checkbox /deep/ .bf-label-wrap {
  display: none;
}
</style>
